import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";


export default class SystemOutage extends React.Component {

    constructor(props) {
        super(props);
        this.updateVersionBanner = this.updateVersionBanner.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.SystemCrash.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    updateVersionBanner() {
        if (window) {
            //debugger;
            window.location.reload(true);
        }
    }

    // Here is our official "faceplant" message
    render() {
        return (<React.Fragment>
            <div className="container-fluid site-outage-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-3">
                                <div className="outage-light">
                                    <img className="img-fluid" alt="Outage Light" src="/images/outage-light.png" />
                                </div>
                            </div>
                            <div className="col-9">
                                <div className="page-heading">PLEASE BEAR WITH US</div>
                                <p>The site is currently down for maintenance updates.</p>
                                <p>Please check back in a few minutes.</p>
                                <Link to="#" onClick={this.updateVersionBanner}>RELOAD</Link>
                                <div className="outage-bear">
                                    <img className="img-fluid" alt="Outage Bear" src="/images/outage-bear.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }

}
